import React, { Dispatch, SetStateAction } from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { translations } from '../../lib';

export type ConfirmationDialogProps = {
    children: React.ReactNode;
    id?: string;
    idButtonYes?: string;
    idButtonNo?: string;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    onConfirm: () => void;
};

const ConfirmationDialog = ({
    children,
    id,
    idButtonYes,
    idButtonNo,
    open,
    setOpen,
    onConfirm,
}: ConfirmationDialogProps) => {
    return (
        <Dialog open={open} id={id} onClose={() => setOpen(false)} aria-labelledby="confirm-dialog">
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => setOpen(false)}
                    color="inherit"
                    className="btnNo"
                    id={idButtonNo}
                >
                    {translations.NO}
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                    color="primary"
                    className="btnYes"
                    id={idButtonYes}
                >
                    {translations.YES}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
